import { render } from "./TriageAssessment.vue?vue&type=template&id=6c5e33a6"
import script from "./TriageAssessment.vue?vue&type=script&lang=js"
export * from "./TriageAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__